import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Campeonato2022 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 118; i <= 138; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
kits:[],
        kit_path: '/images_fem/kits/todas/',	
      id_list: id_list,
      table1:[{'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':14, 'pg':6,'pe':3,'pp':5,'gf':21,'gc':18,'dif':3, 'pts':21},
	      {'color':'#E42727','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':14, 'pg':5,'pe':3,'pp':6,'gf':26,'gc':28,'dif':-2, 'pts':18},
	      {'color':'#E42727','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':14, 'pg':1,'pe':0,'pp':13,'gf':10,'gc':52,'dif':-42, 'pts':3},
	      {'color':'#295e1e','shortname':'vial', 'rivalName':'Fernández Vial', 'pj':14, 'pg':9,'pe':2,'pp':3,'gf':33,'gc':11,'dif':22, 'pts':29},
	      {'color':'#E42727','shortname':'laserena', 'rivalName':'La Serena', 'pj':14, 'pg':1,'pe':2,'pp':11,'gf':12,'gc':62,'dif':-50, 'pts':5},
	      {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':14, 'pg':12,'pe':0,'pp':2,'gf':48,'gc':4,'dif':44, 'pts':36},
	      {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':14, 'pg':11,'pe':1,'pp':2,'gf':61,'gc':6,'dif':55, 'pts':34},
		{'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':14, 'pg':6,'pe':3,'pp':5,'gf':21,'gc':20,'dif':1, 'pts':21},
		{'color':'#295e1e','shortname':'audax', 'rivalName':'A. Italiano', 'pj':14, 'pg':5,'pe':4,'pp':5,'gf':25,'gc':33,'dif':-8, 'pts':19},
		{'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':14, 'pg':5,'pe':4,'pp':5,'gf':22,'gc':25,'dif':-3, 'pts':19},
		{'color':'#E42727','shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':14, 'pg':5,'pe':0,'pp':9,'gf':21,'gc':50,'dif':-29, 'pts':15},
		{'color':'#E42727','shortname':'everton', 'rivalName':'Everton', 'pj':14, 'pg':3,'pe':3,'pp':8,'gf':18,'gc':40,'dif':-22, 'pts':12},
		{'color':'#E42727','shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':14, 'pg':2,'pe':2,'pp':10,'gf':18,'gc':36,'dif':-18, 'pts':8},
		{'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':14, 'pg':14,'pe':0,'pp':0,'gf':61,'gc':3,'dif':58, 'pts':42},
	      {'color':'#E42727','shortname':'puertomontt', 'rivalName':'Pto. Montt', 'pj':14, 'pg':6,'pe':1,'pp':7,'gf':19,'gc':28,'dif':-9, 'pts':19}],

	table2:[{'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':7, 'pg':1,'pe':1,'pp':5,'gf':5,'gc':17,'dif':-12, 'pts':4},
              {'color':'#295e1e','shortname':'vial', 'rivalName':'Fernández Vial', 'pj':7, 'pg':5,'pe':0,'pp':2,'gf':10,'gc':5,'dif':5, 'pts':15},
              {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':7, 'pg':5,'pe':1,'pp':1,'gf':19,'gc':5,'dif':14, 'pts':16},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':7, 'pg':6,'pe':0,'pp':1,'gf':26,'gc':4,'dif':22, 'pts':18},
                {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':7, 'pg':2,'pe':0,'pp':5,'gf':9,'gc':15,'dif':-6, 'pts':6},
                {'color':0,'shortname':'audax', 'rivalName':'A. Italiano', 'pj':7, 'pg':1,'pe':1,'pp':5,'gf':9,'gc':28,'dif':-19, 'pts':4},
                {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':7, 'pg':1,'pe':0,'pp':6,'gf':7,'gc':24,'dif':-17, 'pts':3},
                {'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':7, 'pg':5,'pe':1,'pp':1,'gf':20,'gc':7,'dif':13, 'pts':16}]
    };
  }

  componentDidMount() {
	this.getKits();
		let newtable = this.sortTable(this.state.table1);
  		this.setState({table1:newtable});
		let newtable2 = this.sortTable(this.state.table2);
                this.setState({table2:newtable2});
	}

 getKits(){

        fetch("https://www.registrosudec.com:5000/kits_femenino", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){

  let subP = this.subText('#295e1e', 'Clasifica a Grupo A');
  let subD = this.subText('#E42727', 'Clasifica a Grupo B');
  let subS = this.subText('#295e1e', 'Clasifica a Semifinales');
  return(

	<div style={{textAlign: 'center' }}>
	      <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Campeonato 2022</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>


	{subP}
	{subD}

	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Grupo A </div>
        <div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subS}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Campeonato 2022</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Campeonato 2022 </div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Campeonato 2022" />
     </div>


  )
}

}
export default Campeonato2022;
